import React, {
    useState
} from 'react';

import { 
    useIonViewWillEnter,
    useIonRouter,
    IonPage,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonGrid,
    IonRow,
    IonCol,
    IonButtons,
    IonButton,
    IonBackButton,
    NavContext,
    IonLabel,
    IonItem,
    IonInput,
    IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonCardContent,
    IonText,
    IonImg,
    IonIcon
} from '@ionic/react';
import { cube, person, cash, paperPlane, wallet, caretForward } from "ionicons/icons";
import { RouteComponentProps } from "react-router-dom";
import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import './Main.css';  

interface WithdrawProp extends RouteComponentProps<{
    address : string,
    amount : string
    }> 
{} 

const WithdrawConfirm : React.FC<WithdrawProp> = ({match}) => {

    const [fee, setFee] = useState('');
    const [amountLeft, setAmountLeft] = useState(0);
    const [msg, setMsg] = useState('');
    const [canSend, setCanSend] = useState(false);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        getData();
    });

    const getData = async () => {
        
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            address : match.params.address,
            amount : match.params.amount
        }

		var server = new NServer();
        await server.getList("withdraw_confirm", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            setFee(server.data.fee);
            setAmountLeft(server.data.left);
            setMsg(server.data.msg);
            setCanSend((server.data.can == "yes"));
        }
	};

    // when save the passcode
    const submit = () => {
        let withdrawAmount = parseFloat(match.params.amount);
        if (withdrawAmount <= 0 || isNaN(withdrawAmount))
        {
            showAlert(GetStr(LANGUAGE.TXT_WIDTHDRAW_INVALID_AMT));
            return;
        }

        router.push('/withdrawpass/' + match.params.address + "/" + withdrawAmount, "forward", "push");
    };

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/withdraw" ></IonBackButton>
                    </IonButtons>

                    <IonTitle><h5>{ GetStr(LANGUAGE.TXT_SENDCON_TITLE) }</h5></IonTitle>
                </IonToolbar>
                <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <IonImg className="icon-pic ion-margin-top" src="/assets/img/check_pic.png" />
                            <IonCard className="flat-card">
                                <IonCardContent>
                                    <div>{ GetStr(LANGUAGE.TXT_WITHDRAW_ADDRESS) }</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={cube} slot="start"></IonIcon>
                                        {match.params.address}
                                    </IonItem>
                                    <div>{ GetStr(LANGUAGE.TXT_SENDCON_AMT) }</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={cash} slot="start"></IonIcon>
                                        <b>$ {match.params.amount}</b>
                                    </IonItem>
                                    <div>{ GetStr(LANGUAGE.TXT_SENDCON_FEE) }</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={paperPlane} slot="start"></IonIcon>
                                        <b>$ {fee}</b>
                                    </IonItem>
                                     <div>{ GetStr(LANGUAGE.TXT_SENDCON_LEFT) }</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={wallet} slot="start"></IonIcon>
                                        <IonText color={ amountLeft < 0 ? "danger" : "" }><b>$ {amountLeft}</b></IonText>
                                    </IonItem>
                                    <div>
                                        {msg}
                                    </div>
                                    <IonButton className="main-but ion-margin-top" color="primary" expand="block" onClick={submit} disabled={!canSend}>
                                        { GetStr(LANGUAGE.TXT_SENDCON_DO) }
                                    </IonButton>
                                </IonCardContent>
                            </IonCard>
                            </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default WithdrawConfirm;